import React from "react";

function Spinner() {
  return (
    <div>
      <div className="lds-dual-ring"></div>
    </div>
  );
}

export default Spinner;
